import styles from './Price.module.scss'

export default function Price({ price }) {
  return (
    <div className={styles.wrap}>
      <div className={styles.price}>
        <img
          alt=""
          role="presentation"
          className={styles.icon}
          src="/img/price.svg"
          width="22"
          height="22"
          loading="lazy"
        />
        <p className={styles.text}>{price}</p>
      </div>
    </div>
  )
}
